import React, {useEffect, useState} from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import {changeAnswer} from "../../modules/answers";
import {changeState, setSelectedItem} from "../../modules/menu";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState, surveyDataState} from "../../state/globalState";
import {getCommCode} from "../../lib/api/code";

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#1b6817',
        },
    },
    textField: {
        width: 300
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        marginLeft: 25
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

/**
 * 설문 문항 컴포넌트 (환급은행)
 */
const Survey13 = (props) => {
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const [bankList, setBankList] = useState([]);
    const [bankCodeList, setBankCodeList] = useState([]);
    const classes = useStyles();
    const dispatch = useDispatch();
    const bankCd = answer.rtnBankGcd;

    const getCommCodeList = async (gropCd) => {
        const { data } = await getCommCode(gropCd)
        setBankCodeList(data.payload);
    };

    useEffect(() => {
        getCommCodeList("HC028");
        // const tmpNatCd = JSON.parse(localStorage.getItem("CO034"));
    }, []);


    useEffect(() => {
        const tmpBankList = bankCodeList.map((item) => {
            return (
                <MenuItem key={item.commDetlsCd} value={item.commDetlsCd}>{item.detlsCdNm}</MenuItem>
            )
        });
        setBankList(tmpBankList);
    }, [bankCodeList]);

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;

        const newState = {
            ...answer,
            [column]: value
        }
        setAnswer(newState);

        setSelectedMenuItem('SURVEY_31');
        setMenuCheck(value !== '');
    };



    return (
        bankList && (
            <>
                <ScrollableAnchor id={"114"}>
                    <div>
                        <Container style={{background: 'transparent', marginBottom: '10px'}}>
                            <SentenceForm
                                title={surveyData[114].title}
                                sentences={surveyData[114].questions}
                                step={114}
                            />
                            <FormControl variant="filled" className={classes.formControl}>
                                <InputLabel id="demo-simple-select-filled-label">
                                    환급 은행을 선택하세요
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-filled-label"
                                    id="demo-simple-select-filled"
                                    style={{width: 250}}
                                    value={bankCd}
                                    defaultValue=""
                                    onChange={(e) => handleInputAnswer(e, 'rtnBankGcd')}
                                >
                                    {bankList}
                                </Select>
                            </FormControl>
                        </Container>
                    </div>
                </ScrollableAnchor>
            </>
        )
    );
};

export default Survey13;
